import { useQuery } from "@tanstack/react-query";
import {
  getOrganizationByToken,
  type OrganizationByTokenResponse,
} from "@/features/auth/services/organizationByToken.service";

// Co-branding page de login : si l'URL porte un `?token=…`, on
// récupère le nom + logo du CSE associé pour remplacer le logo Yeati.
// On garde la donnée en cache « infini » — le branding ne change pas
// entre 2 tentatives de login sur le même token.
export const useOrganizationByToken = (token: string | null | undefined) =>
  useQuery<OrganizationByTokenResponse>({
    queryKey: ["organization-by-token", token],
    queryFn: () => getOrganizationByToken(token as string),
    enabled: Boolean(token),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
